<template>
  <div class="col-12">
    <b-card>
      <b-row slot="header">
        <b-col
          md=""
          cols="12"
          class="text-left text_sm_center"
          v-text="
            `${$lang.azmoonLang.azmoonEdit} (${item.exam_pack_name || ''})`
          "
        />
        <b-col
          md="auto"
          cols="12"
          class="text-center"
          v-text="
            `${$lang.azmoonLang.exam_pack_children.id} : ${item.id || ''}`
          "
        />
      </b-row>
      <b-row>
        <b-col cols="12">
          <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
          <b-tabs v-if="!isLoading" nav-class="questionnaire_tabs">
            <b-tab :lazy="true" active>
              <template v-slot:title>{{ $lang.azmoonLang.base_info }}</template>
              <ExamPackFrom
                v-if="item && Object.keys(item).length"
                :item="item"
                @handleBack="handleBack"
                @submit="save"
                :mode="`edit`"
                ref="examPackFrom"
              />
            </b-tab>
            <b-tab :lazy="true">
              <template v-slot:title>
                {{ $lang.azmoonLang.List_question_packs }}
              </template>
              <DragTable
                v-if="!isLoading"
                class="mt-2"
                :prePage="20"
                :url="examPackChildrenUrl"
                ref="searchexamPackChildren"
                :title="$lang.azmoonLang.List_question_packs"
                :dynamicButtons="buttons"
                :keyLang="`exam_pack_children`"
                :order_url="$config.azmoon.exam_pack_order"
                :order_by="`order:asc`"
                :keyGroup="`parent_id`"
                :faLang="`azmoonLang`"
                :valueGroup="id"
                :permissionButtons="permissionButtons"
                :editRoute="true"
                :removeLabel="$lang.azmoonLang.exercise_remove"
                :remove_item="remove_item"
                :hasAdd="isAdmin(permissionButtons, ['admin'])"
                @handleAdd="isOpen"
              />
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="add_edit_exam_pack_children"
                :title="$lang.azmoonLang.exam_pack"
                size="xl"
                :ok-title="$lang.azmoonLang.submit"
                :cancel-title="$lang.azmoonLang.cancelButton"
                hide-header
              >
                <SelectSearch
                  :title="$lang.azmoonLang.exam_pack"
                  :url="exam_final_url"
                  v-model="examPackSelected"
                  :limitOneSelect="false"
                  :allowFields="$lang.azmoonLang.exam_pack_search_select_fildes"
                  @itemSelected="itemSelected"
                  :params="{ show_as_final: 0 }"
                />
                <template v-slot:modal-footer>
                  <b-button variant="danger" @click="isClose()">
                    {{ $lang.azmoonLang.close }}
                    <i class="fa fa-ban"></i>
                  </b-button>
                </template>
              </b-modal>
            </b-tab>
            <b-tab :lazy="true">
              <template v-slot:title>
                {{ $lang.azmoonLang.question_exam_pack }}
              </template>
              <SearchExamPackQuestion class="px-0" />
            </b-tab>
            <b-tab :lazy="true">
              <template v-slot:title>{{ $lang.azmoonLang.preview }}</template>
              <ExamPackPreview
                v-if="item && Object.keys(item).length"
                :examPack="item"
              />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ExamPackFrom from "./../from/examPackFrom";
import DragTable from "@/components/base/dragTable";
import SelectSearch from "@/components/base/selectSearch";
import SearchExamPackQuestion from "./../exam_pack_question/searchExamPackQuestion";
import ExamPackPreview from "./../examPackPreview/examPackPreview";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "edit-exam-pack",
  components: {
    ExamPackFrom,
    SelectSearch,
    DragTable,
    SearchExamPackQuestion,
    ExamPackPreview,
    LoadingSpinner,
  },
  inject: ["examPackRepository", "azmoonRepository"],
  data() {
    return {
      item: {},
      examPackSelected: [],
      isLoading: false,
      isCollpased: false,
      id: this.$route.params.id,
      add_edit_exam_pack_children: false,
      permissionButtons: [],
      buttons: [
        {
          id: "3",
          name: "delete",
        },
      ],
      loadingSpinnerText: this.$lang.receiving_data,
    };
  },
  computed: {
    examPackChildrenUrl() {
      return generateApiUrl(["azmoon", "exam_pack_children"], [this.id]);
    },
    exam_final_url() {
      return generateApiUrl(["azmoon", "exam_pack"]);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    async remove_item(item) {
      let payload = {
        parent_id: null,
      };
      try {
        const response = await this.examPackRepository.partial_edit(
          item.id,
          payload
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async itemSelected(item, event) {
      let payload = {
        parent_id: event == true ? this.id : null,
      };
      try {
        const response = await this.examPackRepository.partial_edit(
          item.id,
          payload
        );
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    isClose() {
      this.add_edit_exam_pack_children = false;
      this.$refs.searchexamPackChildren.fetchData();
    },
    isOpen() {
      this.add_edit_exam_pack_children = true;
      this.examPackSelected = this.$refs.searchexamPackChildren.items.map(
        (x) => {
          if (x.id)
            return {
              id: x.id,
            };
        }
      );
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    async save(payload) {
      try {
        this.isLoading = true;
        this.loadingSpinnerText = this.$lang.sending_data;
        const response = await this.azmoonRepository.edit(this.id, payload);
        this.$notify.success(response.data.message);
        this.handleBack();
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        this.loadingSpinnerText = this.$lang.receiving_data;
        const response = await this.azmoonRepository.find(this.id);
        this.item = pathOr(null, ["data", "data"], response);
        this.permissionButtons = response.data.permissions;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.font-size-bage-info {
  font-size: 13px;
}

.questionnaire_num_btn {
  min-width: 200px;
}

.text_right {
  text-align: right;
}

@media (max-width: 575.98px) {
  .questionnaire_tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .questionnaire_num_btn,
  .questionnaire_tabs li {
    width: 100%;
  }

  .text_sm_center {
    text-align: center !important;
  }
}
</style>
